import React from "react";
import { Route, Switch } from "react-router-dom";
import routes from "../../config/routes/routes";
import PageNotFound from "../App/404";

const AdmininstrationLayout = () => {
  return (
    <div className="d-flex">
      <Switch>
        <Route
          exact
          path={routes.administration.assetRegister.assets.path}
          component={routes.administration.assetRegister.assets.component}
        />
        <Route
          exact
          path={routes.administration.staffRecords.path}
          component={routes.administration.staffRecords.component}
        />
        <Route
          exact
          path={routes.administration.timeSheets.path}
          component={routes.administration.timeSheets.component}
        />
        <Route
          exact
          path={routes.administration.assetIncidentForms.path}
          component={routes.administration.assetIncidentForms.component}
        />
        <Route
          exact
          path={routes.administration.storesRegister.path}
          component={routes.administration.storesRegister.component}
        />
        <Route
          exact
          path={routes.administration.manualsAndPolicies.path}
          component={routes.administration.manualsAndPolicies.component}
        />
        <Route
          exact
          path={routes.administration.staffRecords.staffDetails.path}
          component={routes.administration.staffRecords.staffDetails.component}
        />
        <Route
          exact
          path={routes.administration.staffContracts.path}
          component={routes.administration.staffContracts.component}
        />
        <Route
          exact
          path={routes.administration.staffAppraisals.path}
          component={routes.administration.staffAppraisals.component}
        />
        <Route
          exact
          path={routes.administration.myAppraisals.path}
          component={routes.administration.myAppraisals.component}
        />
        <Route
          exact
          path={routes.administration.leaveApplications.path}
          component={routes.administration.leaveApplications.component}
        />
        <Route
          exact
          path={routes.administration.myLeaveApplications.path}
          component={routes.administration.myLeaveApplications.component}
        />
          <Route
            exact
            path={routes.administration.staffMinutes.path}
            component={routes.administration.staffMinutes.component}
          />
          <Route
            exact
            path={routes.administration.monthlyPayslips.path}
            component={routes.administration.monthlyPayslips.component}
          />
          <Route
            exact
            path={routes.administration.myPayslips.path}
            component={routes.administration.myPayslips.component}
          />
          <Route
            exact
            path={routes.administration.payroll.path}
            component={routes.administration.payroll.component}
          />
        <Route>
          <PageNotFound />
        </Route>
      </Switch>
    </div>
  );
};

export default AdmininstrationLayout;
